import { render, staticRenderFns } from "./ToastHolder.vue?vue&type=template&id=37dceab9"
import script from "./ToastHolder.vue?vue&type=script&lang=js"
export * from "./ToastHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports